<template>
  <label>{{ generateSpace() }}</label>
</template>

<script>
export default {
  name: 'BlankLabel',
  methods: {
    generateSpace() {
      return String.fromCharCode(160);
    },
  },
};
</script>
